export default __webpack_public_path__ + "static/media/iron_point.8263916c.png";